import { render, staticRenderFns } from "./BaseNewReturnOrder.vue?vue&type=template&id=138f9a4b"
import script from "./BaseNewReturnOrder.vue?vue&type=script&lang=js"
export * from "./BaseNewReturnOrder.vue?vue&type=script&lang=js"
import style0 from "./BaseNewReturnOrder.vue?vue&type=style&index=0&id=138f9a4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports